import { useState, useMemo, useCallback, useEffect } from 'react';
import { Box, ButtonBase, makeStyles, Popover } from '@material-ui/core';
import _ from 'lodash';
import { AutoCompleteSelect, Dialog } from '../../../../../components';
import Text from '../../../../../components/Text';
import StyleInput from '../../../../../components/StyleInput';
import { eadmissionAPI } from '../../../../../apis';

const useStyles = makeStyles(() => ({
  btn: {
    color: '#538FFF',
    fontSize: '1rem',
    fontFamily: 'NotoSans-Bold',
  },
  addIcon: {
    fontSize: '1rem',
    marginRight: '0.38rem',
  },
  remarkColorPopup: {
    zIndex: '9999',
  },
  item: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#2e4469',
    padding: '6px 16px',
    justifyContent: 'flex-start',
    textAlign: 'left',
    '&:hover': {
      backgroundColor: '#f1f6ff',
      color: '#538fff',
    },
  },
  star: {
    fontSize: '1rem',
    color: '#FF0300',
  },
}));

function RedirectPopup({ handleClose, eaId, handleRedirect }) {
  const classes = useStyles();
  const [form, setForm] = useState({
    specialtyWardlocId: '',
    remark: '',
  });
  const [redirectList, setRedirectList] = useState([]);
  const [remarkList, setRemarkList] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  console.log('form', form);

  const handleUpdateForm = (key) => (value) => {
    setForm((preForm) => ({
      ...preForm,
      [key]: value,
    }));
  };

  const getRedirectList = useCallback(async () => {
    try {
      const { result } = await eadmissionAPI.getRedirectList({ eaId });
      setRedirectList(result);
    } catch (error) {}
  }, [eaId]);

  useEffect(() => {
    getRedirectList();
  }, [getRedirectList]);

  const redirectOptions = useMemo(() => {
    return _.map(redirectList, (item) => {
      const description = item.redirDesc ? `(${item.redirDesc})` : '';
      const text = `${item.redirHospCode} ${item.redirWardName}${description}`;
      return {
        text,
        value: item,
      };
    });
  }, [redirectList]);

  const getRemarkList = useCallback(async () => {
    try {
      const { result } = await eadmissionAPI.getRemarkList({ status: 1 });
      setRemarkList(result.data);
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    getRemarkList();
  }, [getRemarkList]);

  const handleSubmit = () => {
    handleRedirect({
      remark: form.remark,
      ...form.specialtyWardlocId,
    });
  };

  const submitDisable = useMemo(() => {
    return !form.specialtyWardlocId || !form.remark;
  }, [form.specialtyWardlocId, form.remark]);

  return (
    <>
      <Dialog
        handleClose={handleClose}
        handleConfirm={handleSubmit}
        open={true}
        width="44.375rem"
        title="Redirect"
        confirm="Redirect"
        disabled={submitDisable}
      >
        <Box display="flex" flexDirection="column" gridGap="1.88rem">
          <Box display="flex" flexDirection="column" gridGap="0.63rem">
            <Box display="flex" justifyContent="space-between">
              <Text color="#2E4469" fontSize="1rem">
                Redirect to
              </Text>
            </Box>
            <AutoCompleteSelect
              value={form.specialtyWardlocId}
              onChange={handleUpdateForm('specialtyWardlocId')}
              itemList={redirectOptions}
              placeholder="Redirect"
            />
          </Box>
          <Box display="flex" flexDirection="column" gridGap="0.63rem">
            <Box display="flex" justifyContent="space-between">
              <Text color="#2E4469" fontSize="1rem">
                Reason<span className={classes.star}>*</span>
              </Text>
              {/* <ButtonBase className={classes.btn} onClick={(event) => setAnchorEl(event.currentTarget)}>
                <AddIcon className={classes.addIcon} /> Add Remarks
              </ButtonBase> */}
            </Box>
            <StyleInput placeholder="Reason" onChange={handleUpdateForm('remark')} value={form.remark} />
          </Box>
        </Box>
      </Dialog>
      {/* Add Remark Popup */}
      <Popover
        className={classes.remarkColorPopup}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        placement="bottom"
        transition
        onClose={() => setAnchorEl(null)}
      >
        <Box
          display="flex"
          flexDirection="column"
          minWidth="13rem"
          maxWidth="25rem"
          border="solid 1px #e4e7eb"
          bgcolor="#fff"
          boxShadow="0 1px 6px 0 rgba(0, 0, 0, 0.12)"
          borderRadius="10px"
          padding="0.5rem 0"
          maxHeight="22rem"
          overflow="auto"
        >
          {remarkList.length > 0 ? (
            remarkList.map((item) => (
              <ButtonBase
                className={classes.item}
                key={item.remarkId}
                onClick={() => {
                  handleUpdateForm('remark')(item.remark);
                  setAnchorEl(null);
                }}
              >
                {item.remark}
              </ButtonBase>
            ))
          ) : (
            <ButtonBase className={classes.item} disabled>
              No Option
            </ButtonBase>
          )}
        </Box>
      </Popover>
    </>
  );
}

export default RedirectPopup;
